import styles from './MenuTools.module.css'
import ModalEditMenu from '../Modal/ModalEditMenu'
import PopupDeleteQuestionOption from '../Popups/PopupDeleteQuestionOption'
import PopupAlertMessage from '../Popups/PopupAlertMessage'
import DescriptionIconMenuTools from './DescriptionIconMenuTools'
import { useContext, useState } from 'react'
import { DataContext } from '../DataContext'
import { MdDelete } from "react-icons/md"
import { Link, useOutletContext } from 'react-router-dom'
import { FaPlusCircle } from "react-icons/fa"

function MenuTools({ questionMain, optionMain, optionMainNumberId, questionMulti, 
  optionMulti, optionMultiNumberId, setAnswerDescriptionDisplay, setDescriptionDisplay }) {

  // pegando as variáveis através do 'useContext' do componente 'DataContext'
  const { listUnicQuestionsContext, listUnicOptionsContext, listMultiQuestionsContext, listMultiOptionsContext, listThreeMultiQuestionsContext, listThreeMultiOptionsContext, deleteApi, setDeleteApi, ableDisableMenuTools, setAbleDisableMenuTools } = useContext(DataContext)

  const { activePageDemo, activePageMain, activePageMulti, activePageThreeMulti, setActivateNavigateDefault, setPathNavigate, setActivePauseTimer } = useOutletContext()

  const [activePopupDelete, setActivePopupDelete] = useState(false) // ativa o componente 'PopupDeleteQuestionOption'
  const [staticQuestionAlert, setStaticQuestionAlert] = useState(false) // ativa o componente PopupAlertMessage
  const [activeDescriptionIcon, setActiveDescriptionIcon] = useState('')

  // função que deleta a questão de única escolha atual
  async function onDeleteQuestion(questionMain) {
    const url = `http://localhost:3001/listQuestionsMain/${questionMain.id}`

    const options = {
        method: "DELETE",
    }

    setDeleteApi(false)

    await fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw new Error('Error deleting')

      } else {
        response.json()
        setDeleteApi(true)

      }

    })
    .catch((error) => {
        console.error('Erro:', error)
    })

  }

  // função que deleta a opção de única escolha atual
  async function onDeleteOption(optionMainNumberId) {
    const url = `http://localhost:3001/listOptionsMain/${optionMainNumberId[1]}`

    const options = {
        method: "DELETE",
    }

    setDeleteApi(false)

    await fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw new Error('Error deleting')

      } else {
        response.json()
        setDeleteApi(true)

      }

    })
    .catch((error) => {
        console.error('Erro:', error)
    })

  }

  // função que deleta a questão de múltipla escolha atual
  async function onDeleteQuestionMulti(questionMulti) {
    const url = `http://localhost:3001/listQuestionsMulti/${questionMulti.id}`

    const options = {
        method: "DELETE",
    }

    setDeleteApi(false)

    await fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw new Error('Error deleting')

      } else {
        response.json()
        setDeleteApi(true)

      }

    })
    .catch((error) => {
        console.error('Erro:', error)
    })

  }

  // função que deleta a opção de múltipla escolha atual
  async function onDeleteOptionMulti(optionMultiNumberId) {
    const url = `http://localhost:3001/listOptionsMulti/${optionMultiNumberId[1]}`

    const options = {
        method: "DELETE",
    }

    setDeleteApi(false)

    await fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw new Error('Error deleting')

      } else {
        response.json()
        setDeleteApi(true)

      }

    })
    .catch((error) => {
        console.error('Erro:', error)
    })

  }

  // função que deleta a questão de múltipla escolha atual
  async function onDeleteQuestionThreeMulti(questionMulti) {
    const url = `http://localhost:3001/listQuestionsThreeMulti/${questionMulti.id}`

    const options = {
        method: "DELETE",
    }

    setDeleteApi(false)

    await fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw new Error('Error deleting')

      } else {
        response.json()
        setDeleteApi(true)

      }

    })
    .catch((error) => {
        console.error('Erro:', error)
    })

  }

  // função que deleta a opção de múltipla escolha atual
  async function onDeleteOptionThreeMulti(optionMultiNumberId) {
    const url = `http://localhost:3001/listOptionsThreeMulti/${optionMultiNumberId[1]}`

    const options = {
        method: "DELETE",
    }

    setDeleteApi(false)

    await fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw new Error('Error deleting')

      } else {
        response.json()
        setDeleteApi(true)

      }

    })
    .catch((error) => {
        console.error('Erro:', error)
    })

  }

  function listMatchedQuestionsOptions() { // função que mostra todas as questões e opções correspondentes da Main e MultiMain
    let matched = null

    // Main
    const listNumbersQuestionsMain = listUnicQuestionsContext.map(question => question.questionNumber)    
    const listNumbersOptionsMain = listUnicOptionsContext.map(option => option.optionNumber)
    // Multi
    const listNumbersQuestionsMulti = listMultiQuestionsContext.map(question => question.questionNumber)    
    const listNumbersOptionsMulti = listMultiOptionsContext.map(option => option.optionNumber)    
    // ThreeMulti
    const listNumbersQuestionsThreeMulti = listThreeMultiQuestionsContext.map(question => question.questionNumber)    
    const listNumbersOptionsThreeMulti = listThreeMultiOptionsContext.map(option => option.optionNumber)
 
    if (activePageMain && questionMain) {      
      matched = listNumbersQuestionsMain.filter(question => listNumbersOptionsMain.includes(question))

    } else if (activePageMulti && questionMulti) {
      matched = listNumbersQuestionsMulti.filter(question => listNumbersOptionsMulti.includes(question))

    } else if (activePageThreeMulti && questionMulti) {
      matched = listNumbersQuestionsThreeMulti.filter(question => listNumbersOptionsThreeMulti.includes(question))

    }
      
    return matched

  }

  function deleteMain() { // função que deleta a questão e opção correspondente da página 'NewPageMain'
    if (activePageDemo) {
      setStaticQuestionAlert(true)
      setActivePopupDelete(false)

    } else {
      if (listMatchedQuestionsOptions().length === 1) {
        onDeleteQuestion(questionMain)
        onDeleteOption(optionMainNumberId)
        setAnswerDescriptionDisplay(styles.invisibleAnswerDescription) // tornar a resposta da próxima questão invisível
        setDescriptionDisplay(styles.invisibleDescription) // tornar a descrição da próxima questão invisível
        console.log('Deleted successfully!')
        setDeleteApi(!deleteApi)
        setActivePauseTimer(false) // desativa o pause do Timer ao mudar de página, retorna ao valor inicial

        if (listMultiQuestionsContext.length >= 1) {
          setPathNavigate('/page-multi')
          setActivateNavigateDefault(true)

        } else if (listThreeMultiQuestionsContext.length >= 1) {
          setPathNavigate('/page-three-multi')
          setActivateNavigateDefault(true)

        } else {
          setPathNavigate('/')
          setActivateNavigateDefault(true)

        }

      } else if (listMatchedQuestionsOptions().length > 1) { // só deletar se tiver pelo menos 3 ou mais questões e opções da página Main       
        onDeleteQuestion(questionMain)
        onDeleteOption(optionMainNumberId)
        setAnswerDescriptionDisplay(styles.invisibleAnswerDescription) // tornar a resposta da próxima questão invisível
        setDescriptionDisplay(styles.invisibleDescription) // tornar a descrição da próxima questão invisível
        console.log('Deleted successfully!')
        setDeleteApi(!deleteApi)
        setActivePauseTimer(false) // desativa o pause do Timer ao mudar de página, retorna ao valor inicial
      
      } 
      
    }
    
  }

  function deleteMulti() { // função que deleta a questão e opção correspondente da página 'PageMulti'
    if (listMatchedQuestionsOptions().length === 1) { // só deletar se tiver pelo menos 3 ou mais questões e opções da página Multi
      onDeleteQuestionMulti(questionMulti)
      onDeleteOptionMulti(optionMultiNumberId)
      setAnswerDescriptionDisplay(styles.invisibleAnswerDescription) // tornar a resposta da próxima questão invisível
      setDescriptionDisplay(styles.invisibleDescription) // tornar a descrição da próxima questão invisível
      console.log('Deleted successfully!')
      setDeleteApi(!deleteApi)
      setActivePauseTimer(false) // desativa o pause do Timer ao mudar de página, retorna ao valor inicial

      if (listUnicQuestionsContext.length >= 1) {
        setPathNavigate('/page-main')
        setActivateNavigateDefault(true)

      } else if (listThreeMultiQuestionsContext.length >= 1) {
        setPathNavigate('/page-three-multi')
        setActivateNavigateDefault(true)

      } else {
        setPathNavigate('/')
        setActivateNavigateDefault(true)

      }
    
    } else if (listMatchedQuestionsOptions().length > 1) { // só deletar se tiver pelo menos 3 ou mais questões e opções da página Main       
      onDeleteQuestionMulti(questionMulti)
      onDeleteOptionMulti(optionMultiNumberId)
      setAnswerDescriptionDisplay(styles.invisibleAnswerDescription) // tornar a resposta da próxima questão invisível
      setDescriptionDisplay(styles.invisibleDescription) // tornar a descrição da próxima questão invisível
      console.log('Deleted successfully!')
      setDeleteApi(!deleteApi)
      setActivePauseTimer(false) // desativa o pause do Timer ao mudar de página, retorna ao valor inicial
    
    } 

  }
  
  function deleteThreeMulti() { // função que deleta a questão e opção correspondente da página 'PageThreeMulti'
    if (listMatchedQuestionsOptions().length === 1) { // só deletar se tiver pelo menos 3 ou mais questões e opções da página Multi
      onDeleteQuestionThreeMulti(questionMulti)
      onDeleteOptionThreeMulti(optionMultiNumberId)
      setAnswerDescriptionDisplay(styles.invisibleAnswerDescription) // tornar a resposta da próxima questão invisível
      setDescriptionDisplay(styles.invisibleDescription) // tornar a descrição da próxima questão invisível
      console.log('Deleted successfully!')
      setDeleteApi(!deleteApi)
      setActivePauseTimer(false) // desativa o pause do Timer ao mudar de página, retorna ao valor inicial

      if (listUnicQuestionsContext.length >= 1) {
        setPathNavigate('/page-main')
        setActivateNavigateDefault(true)

      } else if (listMultiQuestionsContext.length >= 1) {
        setPathNavigate('/page-multi')
        setActivateNavigateDefault(true)

      } else {
        setPathNavigate('/')
        setActivateNavigateDefault(true)

      } 
    
    } else if (listMatchedQuestionsOptions().length > 1) { // só deletar se tiver pelo menos 3 ou mais questões e opções da página Main       
      onDeleteQuestionThreeMulti(questionMulti)
      onDeleteOptionThreeMulti(optionMultiNumberId)
      setAnswerDescriptionDisplay(styles.invisibleAnswerDescription) // tornar a resposta da próxima questão invisível
      setDescriptionDisplay(styles.invisibleDescription) // tornar a descrição da próxima questão invisível
      console.log('Deleted successfully!')
      setDeleteApi(!deleteApi)
      setActivePauseTimer(false) // desativa o pause do Timer ao mudar de página, retorna ao valor inicial
    
    }

  }

  // função para habilitar e desabilitar o Menu
  function ableDisableMenu() {
    // usando o 'operador ternário'
    ableDisableMenuTools === styles.disableMenu 
    ? setAbleDisableMenuTools(styles.menuIcons)
    : setAbleDisableMenuTools(styles.disableMenu)

  }

  return (
    <div className={styles.menu}>
      <div
        onClick={ableDisableMenu}
        className={styles.menuTools}
      >
        <span>Menu</span>

      </div>

      <div 
        className={`menuToolsSelector ${styles.menuToolsSelector} ${ableDisableMenuTools}`}        
      >
        {/* icon plus */}
        <Link className={styles.containerDescriptionIcon} to='/page-create'>
          {activeDescriptionIcon && 
            <DescriptionIconMenuTools 
              activeDescriptionIcon={activeDescriptionIcon} 
              key={'create'} 
              text={'create'} 
            />
          }

          <FaPlusCircle 
            onMouseOver={() => setActiveDescriptionIcon('create')}
            onMouseOut={() => setActiveDescriptionIcon('')}
            className={styles.plusIcon}
          />
        </Link>

        {/* icon edit */}
        <ModalEditMenu 
          questionMain={questionMain} 
          questionMulti={questionMulti}
          optionMain={optionMain} 
          optionMulti={optionMulti}
          optionMainNumberId={optionMainNumberId}
          optionMultiNumberId={optionMultiNumberId}
          activeDescriptionIcon={activeDescriptionIcon}
          setActiveDescriptionIcon={setActiveDescriptionIcon}
        />

        {/* icon delete */}
        <div className={styles.containerDescriptionIcon}>
          {activeDescriptionIcon && 
            <DescriptionIconMenuTools 
              activeDescriptionIcon={activeDescriptionIcon} 
              key={'delete'}
              text={'delete'} 
            />
          }

          <MdDelete
            onClick={() => {setActivePopupDelete(true)}}
            onMouseOver={() => setActiveDescriptionIcon('delete')}
            onMouseOut={() => setActiveDescriptionIcon('')}
            className={styles.deleteIcon}            
          />

        </div>

        {/* PopupDeleteQuestionOption */}
        {activePopupDelete && 
        <PopupDeleteQuestionOption
          specificStyles={styles.popupDelete} 
          textPopup={"Are you sure you want to delete?"}
          activePopup={setActivePopupDelete}
          activeButtons={activePopupDelete}
          questionMain={questionMain}
          questionMulti={questionMulti}
          deleteMain={deleteMain}
          deleteMulti={deleteMulti}
          deleteThreeMulti={deleteThreeMulti}
        />}

        {/* PopupAlertMessage */}
        {staticQuestionAlert && 
          <PopupAlertMessage
            text="This is a static question and cannot be removed."
            activePopup={setStaticQuestionAlert}
            specificStyles={styles.popupAlertMessage}
          /> 
        }

      </div>

    </div>

  )

}

export default MenuTools;
